import { render, staticRenderFns } from "./CreatePOI.vue?vue&type=template&id=2d91ef68&scoped=true"
import script from "./CreatePOI.vue?vue&type=script&lang=js"
export * from "./CreatePOI.vue?vue&type=script&lang=js"
import style0 from "./CreatePOI.vue?vue&type=style&index=0&id=2d91ef68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91ef68",
  null
  
)

export default component.exports